import React from 'react'
import Style from '../styles/components/faq.module.scss'

export default (props) => (
  <section className={Style.container}>
    <h2>{props.title.text}</h2>
    <div dangerouslySetInnerHTML={{ __html: props.description.html }}></div>
  </section>
);
